export default __webpack_public_path__ + "is-post-mail.ef8d85171739f5b3c1002207b2ee87d8.png";